/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookmarkedPressRelease,
    BookmarkedPressReleaseFromJSON,
    BookmarkedPressReleaseFromJSONTyped,
    BookmarkedPressReleaseToJSON,
} from './BookmarkedPressRelease';

/**
 * 
 * @export
 * @interface HistoryPressReleasesResponseAllOfData
 */
export interface HistoryPressReleasesResponseAllOfData {
    /**
     * 今まで閲覧したプレスリリース一覧
     * @type {Array<BookmarkedPressRelease>}
     * @memberof HistoryPressReleasesResponseAllOfData
     */
    pressReleases: Array<BookmarkedPressRelease>;
    /**
     * 次のデータを取得する開始点となる識別子
     * @type {string}
     * @memberof HistoryPressReleasesResponseAllOfData
     */
    nextCursor?: string;
}

export function HistoryPressReleasesResponseAllOfDataFromJSON(json: any): HistoryPressReleasesResponseAllOfData {
    return HistoryPressReleasesResponseAllOfDataFromJSONTyped(json, false);
}

export function HistoryPressReleasesResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryPressReleasesResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleases': ((json['press_releases'] as Array<any>).map(BookmarkedPressReleaseFromJSON)),
        'nextCursor': !exists(json, 'next_cursor') ? undefined : json['next_cursor'],
    };
}

export function HistoryPressReleasesResponseAllOfDataToJSON(value?: HistoryPressReleasesResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_releases': ((value.pressReleases as Array<any>).map(BookmarkedPressReleaseToJSON)),
        'next_cursor': value.nextCursor,
    };
}

